import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {positions$, marginRatioCache$} from './positions';
import {copyTradePositionMap$, airdropPositions$} from '@/positions/all/positions-all';
import {updateAirdropPosition$} from '@/positions/airdrop-position';
import type {MarginLevel, Position} from '@/types';

export interface UPositions {
  type: 'positions';
  data: {
    positions: Position[];
  };
}

export interface UAirdropPositions {
  type: 'airdrop-positions';
  data: {
    positions: Position[];
  };
}

export interface UPositionsCopyTrade {
  type: 'positions-copy-trade';
  data: {
    positions: Position[];
  };
}

export interface UContractMarginLevel {
  type: 'contract-margin-level';
  data: {
    marginLevels: MarginLevel[];
  };
}

export interface UUpdateAirdropPositions {
  type: 'update-airdrop-positions';
}

export function subscribePosition() {
  positions$
    .pipe(map<Position[], UPositions>((positions) => ({type: 'positions', data: {positions}})))
    .subscribe((msg) => toUiMsg$.next(msg));

  copyTradePositionMap$
    .pipe(
      map((e) => [].concat(...e.toArray())),
      map((positions: Position[]) => ({type: 'positions-copy-trade' as const, data: {positions}}))
    )
    .subscribe((msg) => toUiMsg$.next(msg));

  marginRatioCache$
    .pipe(
      map((o) => [].concat(...o.toArray())),
      map((marginLevels: MarginLevel[]) => <UContractMarginLevel>{type: 'contract-margin-level', data: {marginLevels}})
    )
    .subscribe((msg) => toUiMsg$.next(msg));

  airdropPositions$
    .pipe(map<Position[], UAirdropPositions>((positions) => ({type: 'airdrop-positions', data: {positions}})))
    .subscribe((msg) => toUiMsg$.next(msg));

  updateAirdropPosition$
    .pipe(
      map<boolean, UUpdateAirdropPositions>(() => ({
        type: 'update-airdrop-positions',
      }))
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}
